import styled from 'styled-components';
import { StyledAdminListRow } from '../../AdminListHeaderCell/styles/StyledAdminListRow';
import { StyledButton } from 'components/shared/Button/styles';

export const StyledAdminGroupPoolConfigsListRow = styled.div`
  ${StyledAdminListRow}

  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
              opacity 0.3s ease-in-out,
              margin-bottom 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;

  ${StyledButton} {
    @media (min-width: 768px) and (max-width: 1440px) {
      padding: 0.8rem 1.8rem;
      font-size: 1.2rem;
    }

    @media (min-width: 1440px) and (max-width: 2118px) {
      padding: 0.8rem 2.6rem;
      font-size: 1.4rem;
    }

    @media screen and (min-width: 2118px) {
      padding: 0.8rem 2.6rem;
      font-size: 1.4rem;
    }
  }

  input {
    background-color: ${(props) => props.theme.bg4};
    border: none;
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.text1 : props.theme.text1)};
    font-size: 1.4rem;
    font-weight: 500;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  input:focus {
    outline: 0;
  }

  .admin-list-cell-container {
    &.id,
    &.priority,
    &.port,
    &.algorithm,
    &.maxattempts,
    &.actions,
    &.order {
      flex-basis: initial;
      flex-grow: 0;
    }

    &.id,
    &.priority {
      width: 10.4rem;
    }

    &.actions {
      width: 10.8rem;

      @media (min-width: 768px) and (max-width: 1440px) {
        width: 8.8rem;
      }
    }

    &.order {
      width: 7.8rem;

      @media (min-width: 768px) and (max-width: 1440px) {
        width: 6.8rem;
      }
    }

    &.port,
    &.algorithm,
    &.maxattempts {
      width: 14.4rem;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }

  .admin-list-cell-order-container {
    display: flex;
    justify-content: space-between;
  }

  .admin-list-cell-change-order-up,
  .admin-list-cell-change-order-down {
    cursor: pointer;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 1.6rem;
      height: 1.6rem;
      fill: ${(props) => props.theme.text2};
      transition: transform 0.2s;

      @media (min-width: 768px) and (max-width: 1440px) {
        width: 1.4rem;
        height: 1.4rem;
      }

      @media screen and (max-width: 768px) {
        width: 1.2rem;
        height: 1.2rem;
      }
    }

    &:hover svg {
      fill: ${(props) => props.theme.button1};
    }
  }

  .admin-list-cell-change-order-up {
    transform: rotate(180deg);
  }
`;
